(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["ac-products"] && !Shopify.designMode) return;
  try {
    

if (!customElements.get('ac-products-slider')) {

  customElements.define(
    'ac-products-slider',

    class extends HTMLElement {

      connectedCallback() {

        this.frame =
          requestAnimationFrame(
            () => this.initialize()
          );

      }


      initialize() {

        this.track =
          this.querySelector(
            '.ac-slider-track'
          );


        if (
          !this.track ||
          this.controller
        ) return;


        this.previous =
          this.querySelector(
            '[data-ac-prev]'
          );


        this.next =
          this.querySelector(
            '[data-ac-next]'
          );


        this.controls =
          this.querySelector(
            '.ac-slider-controls'
          );


        this.controller =
          new AbortController();


        const options = {
          signal:
            this.controller.signal
        };


        this.previous.addEventListener(
          'click',
          () => this.move(-1),
          options
        );


        this.next.addEventListener(
          'click',
          () => this.move(1),
          options
        );


        this.track.addEventListener(
          'scroll',
          () => this.update(),
          {
            ...options,
            passive: true
          }
        );


        this.track.addEventListener(

          'keydown',

          event => {

            if (
              event.target !==
              this.track
            ) return;


            if (
              event.key === 'ArrowRight' ||
              event.key === 'ArrowLeft'
            ) {

              event.preventDefault();


              this.move(
                event.key === 'ArrowRight'
                  ? 1
                  : -1
              );

            }

          },

          options

        );


        this.observer =
          new ResizeObserver(
            () => this.update()
          );


        this.observer.observe(
          this.track
        );


        this.update();

      }


      move(direction) {

        const card =
          this.track.querySelector(
            '.ac-product'
          );


        if (!card) return;


        const gap =
          parseFloat(
            getComputedStyle(
              this.track
            ).columnGap
          ) || 0;


        const visible =
          matchMedia(
            '(max-width:749px)'
          ).matches
            ? 2
            : 4;


        const distance =
          (
            card
              .getBoundingClientRect()
              .width +
            gap
          ) *
          visible;


        this.track.scrollBy({

          left:
            direction *
            distance,

          behavior:
            matchMedia(
              '(prefers-reduced-motion:reduce)'
            ).matches
              ? 'instant'
              : 'smooth'

        });

      }


      update() {

        const max =
          this.track.scrollWidth -
          this.track.clientWidth;


        this.controls.hidden =
          max < 2;


        this.previous.disabled =
          this.track.scrollLeft < 2;


        this.next.disabled =
          this.track.scrollLeft >=
          max - 2;

      }


      disconnectedCallback() {

        cancelAnimationFrame(
          this.frame
        );


        this.controller?.abort();


        this.controller =
          null;


        this.observer?.disconnect();

      }

    }

  );

}


  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();
})();
